<template lang="html">
  <app-layout>

    <div class="brow justify-content-center">
        
        <div class="col-12 col-sm-6 col-lg-4 wrkt" v-for="plan in trainingsPlans">
          <router-link :to="{name: 'workoutShow', params: {id: plan.id}}" class="box" v-ripple>

            <v-layout row wrap align-center>
              <v-flex xs8>
                <div class="cntr pa-1">
                  <div class='innerBox'>
                    
                    <v-img :src="plan.attributes.image_url" contain></v-img>
                  </div>
                </div>
              </v-flex>
              <v-flex xs4>
                <div class="lft small py-2">
                  <v-layout row wrap>
                    <v-flex xs9>
                      <div class="rgt pa-1">
                        <p class='mb-1 loud thin'>Tasks:</p>
                        <p class='mb-0 thin'>Sets:</p>
                      </div>
                    </v-flex>
                    <v-flex xs3>
                      <div class="lft pa-1">
                        <p class='mb-1 loud'>{{ plan.relationships.plan_trainings.data.length }}</p>
                        <p class='mb-0'>3</p>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>

            <div v-if="3 === 4" class="imgBox" :style="'background-image: url(' + plan.attributes.image_url + ')'">
              <img src="../../assets/images/blank_bg.png" class="responsive" />
            </div>

          </router-link>
        </div>
        
      </div>
      
      <bottom-nav />

  </app-layout>
</template>

<script>
import FullBox      from '@/components/ui/FullBox.vue';
import axios        from '@/services/axios';
import UiSpinner    from '@/components/ui/Spinner';
import trainingTile    from '@/views/workouts/trainingTile';
import BottomNav from '@/components/layout/BottomNav';

import { mapGetters } from 'vuex'


export default {
  
  name: 'WorkoutsList',
  data(){
    return {
      // fetched:        false,
      // trainingsPlans: [],
      // trainings:      []
    }
  },
  mounted() {
    console.log("trainings_plans mounted!");
    if (!this.fetched || this.trainingsPlans.length < 1) {
      this.$store.dispatch('getPlans');
    }
  },
  activated() {
    console.log("trainings_plans mounted!");
    if (!this.fetched || this.trainingsPlans.length < 1) {
      this.$store.dispatch('getPlans');
    }
  },
  // computed: mapState(['trainings', 'trainingsPlans']),
  computed: {
    ...mapGetters({
      trainingsPlans: 'getTrainingsPlans',
      trainings:      'getTrainings',
      getTraining:    'getTraining',
      fetched:        'trainingsFetched',
      activeWorkout:  'activeWorkout'
    })
  },
  methods: {
    someMSG() {
      // ..
    },
    // getTraining(that) {
    //   console.log("getTraining", that)
    //   let result = false
    //   this.trainings.forEach((x) => {
    //     if ( that.id === x.id ) {
    //       console.log("foundTraining", x)
    //       result = x
    //     }
    //   })
    //   return result
    // }
  },
  components: {
    FullBox,
    UiSpinner,
    trainingTile,
    BottomNav
  }
}
</script>

<style lang="scss">

.application {
  .wrkt a.box, a.wrkt .box, a.wrkt .box.blank {
    background: rgba(255,255,255,.95) !important;
    // background: repeating-linear-gradient( -55deg, #444, #444 1px, #fff 1px, #fff 6px );
  }
  &.theme--dark {
    .wrkt a.box, a.wrkt .box.blank {
      background: #37474F !important;
      border-color: #37474F !important;
      // background: repeating-linear-gradient( -55deg, #444, #444 1px, #fff 1px, #fff 6px );
    }
  }

}
</style>
